module.exports = __webpack_public_path__ + "img/battery.b08ea433.svg";